<div class="backModal enCalendar">
  <div class="close closeModal">
    <a (click)="close()" title="cerrar"
      ><span class="cross"></span><span class="sr-only">cerrar</span></a
    >
  </div>
  <div class="aviso">
    <div class="tituloSearch">{{ 'MENSAJE_ANULAR_VENTA' | translate }}</div>
    <div class="faturacion-fila">
      <div class="ticket-info">
        <div class="inputControl botones">
          <button
            type="button"
            value="cancelar"
            id="idCancelarButton"
            class="cancelar"
            (click)="close()"
          >
            {{ 'CANCELAR' | translateV2 }}
          </button>
        </div>
      </div>
      <div class="ticket-info">
        <div class="inputControl botones">
          <button
            type="button"
            value="ACEPTAR"
            id="idAceptarButton"
            [disabled]="pulsado"
            class="pagar aceptar"
            (click)="anularVenta()"
          >
            {{ 'CONFIRMAR' | translateV2 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
